/**
 * One number format for the whole app.
 *
 * There were two — thirteen call sites on `en-GB` and five on `nb-NO` — so the
 * same figure was written `4,997` on one screen and `4 997` on the next. The
 * staff persona round flagged locale consistency as a question worth asking;
 * having two answers at once was not one of the options.
 *
 * Norwegian, because the design is Norwegian throughout and the team is here.
 * That is a decision rather than a default, and it now lives in one place, so
 * changing it for an international team is one edit and not eighteen.
 */
export const nf = (n: number): string => n.toLocaleString('nb-NO')
